var map = {
	"app/admin/admin.module": [
		"./src/app/admin/admin.module.ts",
		"admin.module",
		"common"
	],
	"app/donor/donor.module": [
		"./src/app/donor/donor.module.ts",
		"donor.module",
		"common"
	],
	"app/family/family.module": [
		"./src/app/family/family.module.ts",
		"family.module",
		"common"
	],
	"app/settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"settings.module",
		"common"
	],
	"app/tools/tools.module": [
		"./src/app/tools/tools.module.ts",
		"tools.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main